import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const FacultyApplications = ({ onApproved }) => {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("pending");
  const load = () => api.get("/admin/faculty-applications").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const act = async (a, action) => {
    if (action === "reject" && !window.confirm(`Reject ${a.name}'s application?`)) return;
    try {
      await api.post(`/admin/faculty-applications/${a.id}/${action}`);
      toast.success(action === "approve" ? "Approved - profile published and applicant emailed" : "Application rejected");
      load();
      if (action === "approve") onApproved?.();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const shown = rows.filter((r) => filter === "all" || r.status === filter);
  const pending = rows.filter((r) => r.status === "pending").length;

  return (
    <div className="card-warm p-4" data-testid="faculty-applications">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
        <div className="font-display text-lg">Faculty applications {pending > 0 && <span className="ml-1 text-xs bg-[var(--terracotta)] text-white rounded-full px-2 py-0.5" data-testid="faculty-applications-pending-count">{pending} pending</span>}</div>
        <div className="flex gap-1">
          {["pending", "approved", "rejected", "all"].map((f) => (
            <button key={f} onClick={() => setFilter(f)} className={`chip text-xs capitalize ${filter === f ? "bg-[var(--navy)] text-white border-[var(--navy)]" : ""}`} data-testid={`faculty-app-filter-${f}`}>{f}</button>
          ))}
        </div>
      </div>
      {shown.length === 0 ? (
        <div className="text-sm text-zinc-500" data-testid="faculty-applications-empty">No applications in this view.</div>
      ) : (
        <ul className="divide-y divide-[var(--border-warm)]">
          {shown.map((a) => (
            <li key={a.id} className="py-3" data-testid={`faculty-app-${a.id}`}>
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="min-w-0">
                  <div className="font-semibold">{a.name} <span className="text-xs text-zinc-500 font-normal">· {a.title}</span></div>
                  <div className="text-xs text-zinc-600 break-all">{a.email}{a.linkedin ? ` · ${a.linkedin}` : ""} · {new Date(a.created_at).toLocaleDateString()}</div>
                  <div className="text-xs text-zinc-700 mt-1"><b>Expertise:</b> {a.expertise}</div>
                </div>
                {a.status === "pending" ? (
                  <div className="flex gap-2">
                    <button onClick={() => act(a, "approve")} className="btn-terracotta px-3 py-1.5 rounded-full text-xs font-semibold" data-testid={`faculty-app-approve-${a.id}`}>Approve &amp; publish</button>
                    <button onClick={() => act(a, "reject")} className="chip text-xs text-red-700" data-testid={`faculty-app-reject-${a.id}`}>Reject</button>
                  </div>
                ) : (
                  <span className={`text-[10px] font-bold uppercase rounded-full px-2 py-1 ${a.status === "approved" ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"}`}>{a.status}</span>
                )}
              </div>
              <details className="mt-2 text-sm text-zinc-700">
                <summary className="cursor-pointer text-xs font-semibold">Biography &amp; qualifications</summary>
                <p className="mt-2 whitespace-pre-line">{a.bio}</p>
                {a.qualifications && <p className="mt-2 whitespace-pre-line text-xs">{a.qualifications}</p>}
              </details>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
